import moment from 'moment';
import lodash from 'lodash';

export const months = {
  apr:"",
  may:"",
  jun:"",
  jul:"",
  aug:"",
  sep:"",
  oct:"",
  nov:"",
  dec:"",
  jan:"",
  feb:"",
  mar:"",
}
export const processes = [
  {
    id:1,
    sNo:"1",
    rowSpan:2,  
    area_of_process:"Manufacturing Process",
    area_of_functions:"Rough process/ Semi finish process",
    avg_noise_db:"300",
    ...months,
    remarks: ''
  },
  {
    id:2,
    sNo:"2",

    area_of_functions:"Press Shop (Sheet Metal )",
    avg_noise_db:"300",
    ...months,
    remarks: ''
  },
  {
    id:3,
    sNo:"3",
    rowSpan:2,
    area_of_process:"Tool room",
    area_of_functions:"(b)Medium bench and machine work, ordinary automatic machines, rough grinding, medium Drilling and polishing",
    avg_noise_db:"700",
    ...months,
    remarks: ''
  },
  {
    id:4,
    sNo:"4",
    area_of_functions:"Tool Assembly Point.",
    avg_noise_db:"700",
    ...months,
    remarks: ''
  },
  {
    id:5,
    sNo:"5",
    rowSpan:4,
    area_of_process:"Inspection Activity",
    area_of_functions:"Counting Table",
    avg_noise_db:"200",
    ...months,
    remarks: ''
  },
  {id:6,
    sNo:"6",
    area_of_functions:"Part Inspection (Surface Plate )",
    avg_noise_db:"700",
    ...months,
    remarks: ''
  },
  {
    id:7,
    sNo:"7",
    area_of_functions:"Final inspection PDI /Visual Inspection & IFM table",
    avg_noise_db:"700",
    ...months,
    remarks: ''
  },
  {
    id:8,
    sNo:"8",
    area_of_functions:"Red bin Area /Rework Area",
    avg_noise_db:"700",
    ...months,
    remarks: ''
  },
  {
    id:9,
    sNo:"9",  
    rowSpan:1,
    area_of_process:"Shop Floor",
    area_of_functions:"Press Shop /WIP (Sheet Metal )",
    avg_noise_db:"80-90 Db",
    ...months,
    remarks: ''
  },
  {
    id:10,  
    rowSpan:1,
    sNo:"10",  
    area_of_process:"Silence Zone",
    area_of_functions:"Meeting Room",
    avg_noise_db:"65-70 Db",
    ...months,
    remarks: ''
  },
  
  
];

export const initialState = {
  isSubmitted: false,
  report_prepared_by: null,
  report_approved_by: null,
  status:null,
  processes: lodash.cloneDeep(processes),
};
